import { Stack, Typography, Button } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { useCustomisation } from "../../../context/CustomisationContext";
import { useTranslate } from "../../../hooks/useTranslate";
import { getShadeColour } from "../../../utils/helpers";

interface PasswordResetProps {}

export const PasswordReset: React.FC<PasswordResetProps> = () => {
  const { customisations } = useCustomisation();
  const t = useTranslate("new-password");
  const {
    LOGIN: {
      textColorsSettings: loginTextColors,
      buttonsSettings: loginbuttonssettings,
    },
    GPC: {
      textColorsSettings: gpcTextColors,
      buttonsSettings: gpcbuttonssettings,
    },
  } = customisations.customisations;
  const secondaryTextColor =
    loginTextColors?.loginSecondaryTextColor ??
    gpcTextColors?.gpcSecondaryTextColor;
  const secondaryButtonBg =
    loginbuttonssettings?.loginBtnSecondaryBgColor ??
    gpcbuttonssettings?.gpcBtnPrimaryBgColor;
  const secondaryButtonText =
    loginbuttonssettings?.loginBtnSecondaryTextColor ??
    gpcbuttonssettings?.gpcBtnSecondaryTextColor;

  return (
    <>
      <Stack spacing={1} width="100%" alignItems="center">
        <Typography variant="h5" align="center" color={secondaryTextColor}>
          {t("passwordReset", "passwordResetText")}
        </Typography>
        <Typography variant="body1" align="center" color={secondaryTextColor}>
          {t("passwordReset", "passwordResetDsc")}
        </Typography>
      </Stack>
      <Link style={{ textDecoration: "none", width: "100%" }} to={"/login"}>
        <Button
          fullWidth
          sx={{
            py: 1.5,
            borderRadius: "12px",
            backgroundColor: `${secondaryButtonBg} !important`,
            color: `${secondaryButtonText}`,
            "&:hover": {
              bgcolor: `${getShadeColour(secondaryButtonBg!, 5)} !important`,
              fontWeight: 700,
            },
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold">
            {t("passwordReset", "btnLogin")}
          </Typography>
        </Button>
      </Link>
    </>
  );
};
